import { connect } from '../../../../../../common/react-redux';
import makeEditable from '../../../../../../common/components/shared/functionality/makeEditable';
import QuizEntryEditFooter from './presenter';
export function mapStateToProps(state, props) {
  var entry = props.entry,
    quizEntry = props.quizEntry,
    workingQuizEntry = props.workingQuizEntry;
  var workingEntry;
  if (quizEntry.isItem || quizEntry.isBankEntry) {
    workingEntry = workingQuizEntry.getItem();
  } else {
    // This component is repurposed in RegradingOverride where we're editing a
    // quiz entry that doesn't have a specific item. For that case we expect
    // Bank quizEntry with Item entry.
    workingEntry = entry.getWorkingInstance();
  }
  return {
    workingEntry: workingEntry
  };
}
export default makeEditable(connect(mapStateToProps)(QuizEntryEditFooter));